<template>
  <vxe-column v-if="isUnit" title="数量" field="beginQuantity" align="right" width="90">
    <template #default="{row}">
      <!-- && row.unit   如果不是数量核算的科目,数量禁用 jxd-->
      <vxe-input @blur="valChange(row,'beginQuantity')" v-if="canEdit(row) && row.unit" type="number" align="right" v-model.number="row.beginQuantity" :controls="false" size="mini"/>
      <span v-else>{{ row.beginQuantity || '' }}</span>
    </template>
  </vxe-column>
  <vxe-column v-if="isFor&&!isLocal" title="原币" field="beginBalanceFor" align="right" width="120">
    <template #default="{row}">
      <vxe-input @blur="valChange(row,'beginBalanceFor')" v-if="canEdit(row)"  type="number" align="right" v-model.number="row.beginBalanceFor" :controls="false"/>
      <span v-else>{{ row.beginBalanceFor || '' }}</span>
    </template>
  </vxe-column>
  <vxe-column :title="colTitle" field="beginBalance" align="right" width="120">
    <template #default="{row}">
      <vxe-input @blur="valChange(row,'beginBalance')" v-if="canEdit(row)" type="number" align="right" v-model.number="row.beginBalance" :controls="false" size="mini"/>
      <span v-else>{{ row.beginBalance || '' }}</span>
    </template>
  </vxe-column>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "BeginCol",
  props: {
    valChange: Function,
    isUnit: Boolean,
    isFor: Boolean,
    isStartYear: Boolean,
    beginCheck: Boolean,
    isLocal: Boolean,
    type: String,
    currencyName: String,
  },
  computed: {
    colTitle() {
      if (this.isFor) {
        return '本位币';
      }
      return this.isUnit ? '金额' : '期初余额'
    }
  },
  methods: {
    canEdit(row) {
      // console.log(row)
      // if (row.subjectCode=='1012') {
      //   console.log(!this.beginCheck)
      //   console.log(this.type !== '损益' && (row.auxiliaryDetailId !== '0' || (row.leaf && !this.isStartYear && row.auxiliaryAccounting.length === 0)))
      //   console.log(this.type !== '损益')
      //   console.log((row.auxiliaryDetailId !== '0' || (row.leaf && !this.isStartYear && row.auxiliaryAccounting.length === 0)))
      //   console.log((row.auxiliaryDetailId !== '0'))
      //   console.log(((row.leaf && !this.isStartYear && row.auxiliaryAccounting.length === 0)))
      //   console.log(((row.leaf)))
      //   console.log(((!this.isStartYear)))
      //   console.log(((row.auxiliaryAccounting.length === 0)))
      //   console.log(this.currencyName!=='综合本位币')
      //   console.log("")
      // }
      // return !this.beginCheck && (this.type !== '损益' && (row.auxiliaryDetailId !== '0' || (row.leaf && !this.isStartYear && row.auxiliaryAccounting.length === 0))) && this.currencyName!=='综合本位币';
      //去除是否是isStartYear(是否是年初1月份,不知道为何在在这加这个判断)的条件判断
      // console.log("this.currencyName="  + this.currencyName)
      return !this.beginCheck && ((this.type !== '损益' && this.type !== '收入' && this.type !== '支出') && (row.auxiliaryDetailId !== '0' || (row.leaf && row.auxiliaryAccounting.length === 0))) && this.currencyName!=='综合本位币';
    }
  },
}
</script>
